import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import LetSTalkFinance from "./sections/LetSTalkFinance";
import OurHeadquarters from "./sections/OurHeadquarters";
import QuickConnect from "./sections/QuickConnect";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <LetSTalkFinance />
      <OurHeadquarters />
      <QuickConnect />
      <Footer />
    </div>;
}